(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.game = svs.numbergames.game || {};
svs.numbergames.game.animations = {};
svs.numbergames.game.pay = {};
svs.numbergames.game.helpers = {};
svs.numbergames.game.templates = svs.numbergames.game.templates || {};
svs.numbergames.game.utils = svs.numbergames.game.utils || {};
svs.numbergames.game.behaviors = svs.numbergames.game.behaviors || {};
svs.numbergames.game.views = svs.numbergames.game.views || {};
svs.numbergames.game.view_options = svs.numbergames.game.view_options || {};
svs.numbergames.game.logger = new svs.core.log.Logger('numbergames:play');
svs.numbergames.game.huxfluxRadio = 'numbergame:game:huxflux';
svs.numbergames.game.analytics_events = svs.numbergames.game.analytics_events || {
  BETSLIP_COMPLETE: 'Betslip Complete',
  BETROW_STARTED_COMPLETE: 'Betrow Started Complete'
};

 })(window);